import {Box, Icon, IconButton} from "@chakra-ui/react";
import {Button, ButtonProps} from "./ui/button";
import {Tooltip} from "./ui/tooltip";
import {TrashIcon} from "@heroicons/react/16/solid";
import React, {ReactNode} from "react";
import T from "platformed-components/i18n/T";
import useTranslate from "platformed-components/i18n/useTranslate";
import {confirmationDialog} from "../App/Dialogs";
import {useDialogContext} from "./dialogs";
import {ConfirmationDialogProps} from "../App/Dialogs/ConfirmationDialog";

type DeleteButtonProps = {buttonProps?: Partial<ButtonProps>; buttonLabel?: ReactNode} & Omit<
  ConfirmationDialogProps,
  "buttonLabel"
>;

export const DeleteButton = ({buttonProps, buttonLabel = <T keyName="c.Delete" />, ...props}: DeleteButtonProps) => {
  const {open} = useDialogContext();
  return (
    <>
      <Button
        colorPalette="red"
        type="button"
        onClick={() => open(confirmationDialog, {buttonLabel, ...props})}
        {...buttonProps}
      >
        <T keyName="c.Delete" />
      </Button>
    </>
  );
};

type DeleteIconButtonProps = {
  tooltip?: ReactNode;
  buttonProps?: Partial<React.ComponentProps<typeof IconButton>>;
  buttonLabel?: ReactNode;
  children?: ReactNode;
} & Omit<ConfirmationDialogProps, "buttonLabel">;

export const DeleteIconButton = ({
  buttonProps,
  buttonLabel = <T keyName="c.Delete" />,
  tooltip,
  children,
  ...props
}: DeleteIconButtonProps) => {
  const t = useTranslate();
  const {open} = useDialogContext();
  return (
    <Tooltip content={tooltip} disabled={!tooltip}>
      <IconButton
        aria-label={t("c.Delete")}
        onClick={() => open(confirmationDialog, {buttonLabel, ...props})}
        variant="outline"
        color="gray.500"
        colorPalette="gray"
        size="sm"
        {...buttonProps}
      >
        {children ?? <Icon as={TrashIcon} />}
      </IconButton>
    </Tooltip>
  );
};

export const DeletedItem = ({children}: {children: React.ReactNode}) => {
  return (
    <Box
      bg="gray.50"
      fontWeight="500"
      fontSize="md"
      marginY="4"
      padding="4"
      borderRadius="md"
      borderColor="gray.200"
      borderWidth="1px"
    >
      {children}
    </Box>
  );
};
